export default __webpack_public_path__ + "9a5e6afb5d5df8755ea57bdebf952dbe.mp3";